/**
 * Another utility class to help figure out what styles should and shouldn't be applied to the buttons
 * in the cells of the scheduler component.
 */
export default class InspectionTypeScheduleCalendarDayButtonStyles {
  private static SELECTABLE_COLOR = "tw-bg-[#e5e7eb]";
  private static BLOCK_OUT_COLOR = "tw-bg-[#9ca3af]";
  private static SELECTED_COLOR = "tw-bg-[#bfdbfe]";
  private static TRANSPARENT = "tw-bg-transparent";

  private selected: boolean;
  private blockedOut: boolean;

  constructor(selected: boolean, blockedOut: boolean) {
    this.selected = selected;
    this.blockedOut = blockedOut;
  }

  toString(): string {
    return `tw-rounded-full tw-border-none ${this.getBorderHoverColor()} hover:tw-cursor-pointer ${this.getBackgroundColor()} ${this.getHoverBackgroundColor()}`;
  }

  private getBackgroundColor(): string {
    if (this.selected) {
      return "tw-bg-[#bfdbfe]";
    }
    if (this.blockedOut) {
      return InspectionTypeScheduleCalendarDayButtonStyles.TRANSPARENT;
    }
    return InspectionTypeScheduleCalendarDayButtonStyles.SELECTABLE_COLOR;
  }

  private getHoverBackgroundColor(): string {
    if (this.blockedOut && !this.selected) {
      return `hover:${InspectionTypeScheduleCalendarDayButtonStyles.BLOCK_OUT_COLOR}`;
    }
    if (this.selected) {
      return `hover:${InspectionTypeScheduleCalendarDayButtonStyles.SELECTED_COLOR}`;
    }
    return `hover:tw-bg-[#bfdbfe]`;
  }

  private getBorderHoverColor(): string {
    if (this.selected) {
      return "";
    }
    return `hover:tw-ring-blue hover:tw-ring-1`;
  }
}
